// polyfill SVG for Safari. Might not need this
// import 'innersvg-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));
